/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_CONFLICTING_STUDENTS:  ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/verifyClassName',
    GET_ALL_VIEWABLE_STUDENTS: ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getAllViewable',
    GET_ALL_DELETED_STUDENTS: ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getAllDeleted',
    GET_ALL_STUDENTS: ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getAllViewable',
    GET_STUDENT_ACCOUNT_COUNT:ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getCount',
    GET_STUDENTS_IN_CLASS : ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/getStudentsInClass',
    UPDATE_ALL_VIEWABLE_STUDENTS: 'UPDATE__VIEWABLE_ALL_STUDENTS',
    UPDATE_ALL_STUDENTS: 'UPDATE_ALL_STUDENTS',
    UPDATE_STUDENTS_IN_CLASSES : 'UPDATE_STUDENTS_IN_CLASSES',
    GET_STUDENT : ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getStudent',
    GET_STUDENT_RECENT : ENVIRONMENT_CONSTANTS.BASE_URL + '/recentActivity/getAllStudentActivity',
    GET_STUDENT_LANGUAGES : ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getStudentLanguages',
    UPDATE_STUDENT: 'UPDATE_STUDENT',
    UPDATE_STUDENT_LANGUAGES: 'UPDATE_STUDENT_LANGUAGES',
    UPDATE_STUDENT_RECENT:'UPDATE_STUDENT_RECENT',
    EXISITNG_ACCOUNT_STUDENTS:  ENVIRONMENT_CONSTANTS.BASE_URL + '/classController/doesStudentsExist',
    GET_STUDENT_PROGRESS:  ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/getProgressReport',
    EDIT_STUDENT: ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/editStudent',
    DELETE_STUDENT: ENVIRONMENT_CONSTANTS.BASE_URL + '/studentsController/deleteStudent',
    UPDATE_ALL_DELETED_STUDENTS:"UPDATE_ALL_DELETED_STUDENTS",
    REAL_DELETE_STUDENT: ENVIRONMENT_CONSTANTS.BASE_URL + "/studentsController/realDeleteStudent",
}



// WEBPACK FOOTER //
// ./src/constants/students.js